module.exports = __webpack_public_path__ + "img/learner-quiz-Collector-Shadow.f30ba8b3.png";